/*
 *		Copyright (c) 2011-2022 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('accessWebClient')
    .controller('UploadRequestLandingController', [
        '$filter',
        '$q',
        '$scope',
        '$translate',
        'AccountResource',
        'CloudPlatformPresentation',
        'ENV',
        'FILE_DROP_EVENT',
        'EmailTools',
        'flashMessagesService',
        'UPLOADER_EVENT',
        'Uploader',
        'UploadRequest',
        function (
            $filter,
            $q,
            $scope,
            $translate,
            AccountResource,
            CloudPlatformPresentation,
            ENV,
            FILE_DROP_EVENT,
            EmailTools,
            flashMessagesService,
            UPLOADER_EVENT,
            Uploader,
            UploadRequest
        ) {
            var requestID = /upload_requests\/([^\/]+)/.exec(window.location.pathname)[1];
            var userDataInit = {
                firstName: '',
                lastName: '',
                email: '',
                agreement: false
            };

            $scope.isLoading = true;
            $scope.hasError = false;
            $scope.uploadRequest = null;
            $scope.dropZoneTarget = {
                is_directory: true,
                is_deleted: false
            };

            $scope.userData = angular.extend({}, userDataInit);
            $scope.emailPattern = new RegExp('^' + EmailTools.getEmailPattern() + '$', 'i');
            $scope.privacyUrl;
            $scope.termsUrl;

            Object.defineProperties($scope, {
                uploadQueue: {
                    get: function () {
                        return Uploader.queue;
                    }
                },
                allowedUploadQueue: {
                    get: function () {
                        return Uploader.queue.filter(function (file) {
                            return !file.hasError && !file.isSuccess && !file.isUploading;
                        });
                    }
                },
                allowedUploadQueueLength: {
                    get: function () {
                        return this.allowedUploadQueue.length;
                    },
                    set: function () { }
                },
                isUploadQueueFull: {
                    get: function () {
                        return angular.isObject($scope.uploadRequest) && $scope.uploadQueue.length === $scope.uploadRequest.max_file_count;
                    }
                },
                hasFilesWithErrors: {
                    get: function () {
                        return $scope.uploadQueue.some(function (file) {
                            return file.hasError;
                        });
                    }
                },
                hasFailedUploads: {
                    get: function () {
                        return $scope.uploadQueue.some(function (file) {
                            return file.hasError && !(file.error instanceof NotAllowedFileError);
                        });
                    }
                }
            });

            $scope.openFilesDialogue = function () {
                $('.upload-request__files-input').trigger('click');
            }

            $scope.chooseFilesHandler = function (event) {
                Uploader.addToQueue(event.target.files);
                event.target.value = '';
            };

            $scope.removeFromQueue = function (item) {
                Uploader.removeFromQueue(item);
            };

            $scope.getFileStatus = function (file) {
                if (file.isSuccess) {
                    return 'success';
                } else if (file.isUploading) {
                    return 'uploading';
                } else if (file.hasError) {
                    return 'error';
                } else {
                    return 'idle';
                }
            };

            $scope.submitUploadRequest = function ($event, uploadRequestForm) {
                $event.preventDefault();

                if (uploadRequestForm.$invalid) {
                    return;
                }

                $scope.isSubmitting = true;

                $scope.uploadRequest.createSession()
                    .then(function (sessionUUID) {
                        // We create a dummy sync-share instance with minimum required props
                        // in order to be compliant with the Uploader.upload method property
                        var target = {
                            actions: {
                                upload: $scope.uploadRequest.getUploadFileUrl(sessionUUID),
                            },
                            can_be_streamed: true
                        };

                        return Uploader.upload(target, $scope.allowedUploadQueue)
                            .then(function () {
                                if (Uploader.stat.success <= 0) {
                                    flashMessagesService.add(
                                        $translate.instant('upload_requests_landing_page_invalid_message'),
                                        flashMessagesService.ERROR
                                    );
                                    return $q.reject();
                                }

                                return $scope.uploadRequest.submitSession(
                                    sessionUUID,
                                    $scope.userData.firstName,
                                    $scope.userData.lastName,
                                    $scope.userData.email
                                );
                            });
                    })
                    .then(function () {
                        var hasFailedUploads = $scope.hasFailedUploads;

                        if (hasFailedUploads) {
                            flashMessagesService.add($translate.instant('upload_requests_landing_page_partial_success_message'), flashMessagesService.NOTICE);
                        } else {
                            flashMessagesService.add($translate.instant('upload_requests_landing_page_success_message'), flashMessagesService.SUCCESS);
                        }

                        _resetForm(uploadRequestForm);
                    })
                    .catch(function (error) {
                        if (angular.isDefined(error)) {
                            flashMessagesService.add(error.statusText, flashMessagesService.ERROR);
                        }
                    })
                    .finally(function () {
                        $scope.isSubmitting = false;
                    });
            };

            Uploader.on(UPLOADER_EVENT.QUEUE_UPDATED, _onUploadQueueUpdate);
            Uploader.on(UPLOADER_EVENT.ITEM_UPLOAD_UPDATE, _onUploadFileUpdate);

            $scope.$on('$destroy', function () {
                Uploader.off(UPLOADER_EVENT.QUEUE_UPDATED, _onUploadQueueUpdate);
                Uploader.off(UPLOADER_EVENT.ITEM_UPLOAD_UPDATE, _onUploadFileUpdate);
            });

            $scope.$on(FILE_DROP_EVENT.DROPPED, _onFilesDropHandler);

            /**
             * The problem that we need to wait for translations are being loaded in order to:
             * 1. To be sure that error message is being correctly translated (CI env)
             * 2. To avoid FOUC (Flash on untranslated content) effect in positive scenario 
             * 
             * For some reasons, the `$translate.onReady` promise is being resolved 
             * before the actual localization file is being loaded. So, we can't rely on it.
             * The bullet-proof solution for time being will be wait `$translate(key)` promise
             * to be resolved.
             */
            $translate('upload_requests_landing_page_invalid_message')
                .then(function () {
                    return $q.all([
                        UploadRequest.get({ request_uuid: requestID }).$promise,
                        CloudPlatformPresentation.getPrivacyAndTermsLinks(ENV.cloudPlatformBrandId)
                    ]);
                })
                .then(function (responses) {
                    $scope.uploadRequest = responses[0];
                    $scope.privacyUrl = responses[1].privacyUrl;
                    $scope.termsUrl = responses[1].termsUrl;

                    if (!$scope.uploadRequest.isPublic) {
                        return _getUserData();
                    }
                })
                .catch(function () {
                    $scope.hasError = true;
                    flashMessagesService.add($translate.instant('upload_requests_landing_page_invalid_message'), flashMessagesService.ERROR);
                })
                .finally(function () {
                    $scope.isLoading = false;
                });

            function _hasInvalidExtension(file) {
                return $scope.uploadRequest.hasAllowedExtension &&
                    $scope.uploadRequest.allowed_file_extensions.indexOf(file.extension) === -1;
            }

            function _getUserData() {
                return AccountResource.get().$promise
                    .then(function (data) {
                        var lastSpaceIndex = data.name.lastIndexOf(' ')

                        userDataInit.firstName = lastSpaceIndex === -1 ? data.name : data.name.substring(0, lastSpaceIndex).trim();
                        userDataInit.lastName = lastSpaceIndex === -1 ? '' : data.name.substring(lastSpaceIndex).trim();
                        userDataInit.email = data.email;
                        $scope.userData = angular.extend({}, userDataInit);
                    })
            }

            function _exceedsSize(file) {
                return $scope.uploadRequest.hasFileSizeLimit && file.size > $scope.uploadRequest.max_file_size;
            }

            function _validateFile(file) {
                if (_hasInvalidExtension(file)) {
                    var fileExtension = file.extension;

                    if (angular.isDefined(fileExtension)) {
                        file.error = new NotAllowedFileError($translate.instant('upload_requests_landing_page_file_format_warning', {
                            file_format: fileExtension.toUpperCase()
                        }));
                    } else {
                        file.error = new NotAllowedFileError($translate.instant('upload_requests_landing_page_file_format_wo_extension_warning'));
                    }
                } else if (_exceedsSize(file)) {
                    file.error = new NotAllowedFileError($translate.instant('upload_requests_landing_page_file_size_warning', {
                        max_file_size: $filter('fileSize')($scope.uploadRequest.max_file_size)
                    }));
                }
            }

            function _onUploadQueueUpdate() {
                if ($scope.uploadRequest.hasFilesCountLimit && Uploader.queue.length > $scope.uploadRequest.max_file_count) {
                    Uploader.splice(
                        $scope.uploadRequest.max_file_count,
                        Uploader.queue.length - $scope.uploadRequest.max_file_count
                    );
                }

                Uploader.newUploadItems.forEach(_validateFile);

                _safeDigest();
            }

            function _onFilesDropHandler(_, __, dataTransfer) {
                Uploader.addToQueue(dataTransfer, true);
            }

            function _onUploadFileUpdate() {
                _safeDigest();
            }

            function _resetForm(uploadRequestForm) {
                var hasFilesWithErrors = $scope.hasFilesWithErrors;
                var hasFailedUploads = $scope.hasFailedUploads;

                if (!hasFilesWithErrors) {
                    $scope.userData = angular.extend({}, userDataInit);
                    uploadRequestForm.firstName.$setUntouched();
                    uploadRequestForm.lastName.$setUntouched();
                    uploadRequestForm.email.$setUntouched();
                    uploadRequestForm.attachedFiles.$setUntouched();
                    uploadRequestForm.agreement.$setUntouched();
                    uploadRequestForm.$setPristine();
                    Uploader.clearQueue();
                } else if (hasFailedUploads || hasFilesWithErrors) {
                    var successfulUploads = Uploader.queue.filter(function(file) {
                        return !file.hasError;
                    });

                    Uploader.removeFromQueue(successfulUploads);
                    uploadRequestForm.attachedFiles.$setValidity();
                }
            }

            function _safeDigest() {
                if (!$scope.$root.$$phase) {
                    $scope.$digest();
                };
            }

            function NotAllowedFileError(message) {
                this.message = message;
            }
        }
    ]);
